import { render, staticRenderFns } from "./OrderErrorModal.vue?vue&type=template&id=3ce0ce0d&scoped=true"
import script from "./OrderErrorModal.vue?vue&type=script&lang=js"
export * from "./OrderErrorModal.vue?vue&type=script&lang=js"
import style0 from "./OrderErrorModal.vue?vue&type=style&index=0&id=3ce0ce0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce0ce0d",
  null
  
)

export default component.exports